/* import __COLOCATED_TEMPLATE__ from './customer-facing-name-input.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    value: string | null;
  };
}

const CustomerFacingNameInput = templateOnlyComponent<Signature>();
export default CustomerFacingNameInput;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::CustomerFacingNameInput': typeof CustomerFacingNameInput;
    'new-settings/workspace/customer-facing-name-input': typeof CustomerFacingNameInput;
  }
}
